export { default } from "./InventoryItemDetail";

